import React, { Component } from 'react';
import ModalModule from '../modal';
import Utils from '../utils';
import UI from '../ui';

const { Modal, ModalButtonActionType, ModalContext } = ModalModule;
const { WrappedRadioButton, WrappedInputTextareaWithLabel } = UI;
const { Communication, Logger, Session, Util } = Utils;

export default class Feedback extends Component {
	constructor(props) {
		super(props);

		this.state = {
			experience: '',
			features: '',
			problems: '',
		};
	}

	componentDidMount() {
		Logger.saveActionData('Feedback Button Clicked');
	}

	onChangeRadioButtons = ({ value }) => {
		this.setState({
			experience: value,
		});
	};

	onChangeTextArea = ({ target: { value, name } }) => {
		this.setState({
			[name]: value,
		});
	};

	onClickSubmit = async () => {
		const { experience, features, problems } = this.state;
		const { modalId } = this.props;
		const { closeModal, showError } = this.context;
		const previousActions = Logger.getAllActionData();
		const newState = { ...this.state, previousActions };

		// preserve line breaks and use html format
		if (features !== '') {
			newState.features = features.split('\n').join('<br>');
		}

		if (problems !== '') {
			newState.problems = problems.split('\n').join('<br>');
		}

		Logger.logToServer({
			category: 'feedback',
			rating: experience,
			features,
			problems,
			previousActions,
		});

		const response = await Communication.sendEmail({
			TemplateName: 'customerFeedback',
			NvPairs: this.buildEmailParams(newState),
		});

		if (!Communication.isSuccessful(response)) {
			return showError({ response });
		}

		closeModal(modalId, ModalButtonActionType.Ok);
	};

	buildEmailParams = newState => {
		const { experience, features, problems } = newState;
		const { Page = '' } = Session.getSettings();
		const { customerId, customerDetails = {} } = Session.getAccountInfo();
		const { address, email, username } = customerDetails;

		let bodyText = '';

		bodyText += 'Question 1: Please rate your overall experience (1-5, higher is better):<br>';
		bodyText += `Answer: ${experience}`;
		bodyText += '<br><br>';
		bodyText += 'Question 2: What features would you like to see added?<br>';
		bodyText += `Answer: ${features}`;
		bodyText += '<br><br>';
		bodyText += 'Question 3: Did you encounter any problems or issues?<br>';
		bodyText += `Answer: ${problems}`;
		bodyText += '<br><br>';

		return {
			bodyPlainText: bodyText,
			pageName: Page,
			browser: Util.getBrowser(),
			os: Util.getOS(),
			fullName: address.name,
			strFromEmailAddress: email,
			strFirstName: '',
			strFromFirstName: address.name,
			userName: username,
			custId: customerId,
			previousActions: '', // TODO: return previousActions object once https://stamps.atlassian.net/browse/SERVER-32172 is implemented.
			strEmailAddress: 'sdcfeedback@mailva.custhelp.com',
			subject: `${Page} Feedback Submission - Account # ${customerId}`,
		};
	};

	render() {
		const { experience, features, problems } = this.state;
		const { modalId } = this.props;
		const { brandName, contactPhoneNumber = '' } = Session.getBrand();

		const primaryButton = {
			text: 'Submit',
			onClick: this.onClickSubmit,
			dataqa: 'feedback-submit-button',
		};

		return (
			<Modal
				modalId={modalId}
				className="common-feedback"
				header="Feedback"
				primaryButton={primaryButton}
				size="small"
			>
				<div className="body">
					<div className="input-container">
						<p>Please rate your overall experience:</p>
						<div className="experience-container">
							<div className="radio-buttons">
								<div>
									<WrappedRadioButton
										inputId="experience1"
										name="experience1"
										value="1"
										onChange={this.onChangeRadioButtons}
										dataqa="experience1"
										checked={experience === '1'}
									>
										1
									</WrappedRadioButton>
									Poor
								</div>
								<WrappedRadioButton
									inputId="experience2"
									name="experience2"
									value="2"
									onChange={this.onChangeRadioButtons}
									dataqa="experience2"
									checked={experience === '2'}
								>
									2
								</WrappedRadioButton>
								<WrappedRadioButton
									inputId="experience3"
									name="experience3"
									value="3"
									onChange={this.onChangeRadioButtons}
									dataqa="experience3"
									checked={experience === '3'}
								>
									3
								</WrappedRadioButton>
								<WrappedRadioButton
									inputId="experience4"
									name="experience4"
									value="4"
									onChange={this.onChangeRadioButtons}
									dataqa="experience4"
									checked={experience === '4'}
								>
									4
								</WrappedRadioButton>
								<div>
									<WrappedRadioButton
										inputId="experience5"
										name="experience5"
										value="5"
										onChange={this.onChangeRadioButtons}
										dataqa="experience5"
										checked={experience === '5'}
									>
										5
									</WrappedRadioButton>
									Excellent
								</div>
							</div>
						</div>
						<WrappedInputTextareaWithLabel
							label="What features would you like to see added?"
							uiElementConfig={{
								rows: 4,
								cols: 43,
								name: 'features',
								value: features,
								onChange: this.onChangeTextArea,
								autoResize: true,
								dataqa: 'feedback-features',
							}}
						/>
						<WrappedInputTextareaWithLabel
							label="Did you encounter any problems or issues?"
							uiElementConfig={{
								rows: 4,
								cols: 43,
								name: 'problems',
								value: problems,
								onChange: this.onChangeTextArea,
								autoResize: true,
								dataqa: 'feedback-problems',
							}}
						/>
					</div>
					<p>
						<i>
							If you need help, please contact our Customer Care team by{' '}
							<a
								target="_blank"
								href={Util.getSupportEmail(brandName)}
								rel="noreferrer"
							>
								email
							</a>{' '}
							or by calling {contactPhoneNumber}
						</i>
					</p>
				</div>
			</Modal>
		);
	}
}

Feedback.contextType = ModalContext;
